<template>
  <div class="stencilList">
    <div class="leftStencil">
      <div class="leftTil">
        <div>
          <FSpanTil title="模版列表" fontSize="20"></FSpanTil>
        </div>
      </div>
      <div class="leftList">
        <el-scrollbar>
          <div class="forList" v-for="(item,index) in stencilList" :class="{activeForList:item.groupid===activeStencil.id}" @click="getClickModel(index)">
            <div class="stencilDiv">
              <img :src="item.thumbNail" ondragstart="return false" @error="imgError">
              <div class="div_count">
                <span class="name">{{item.screenName}}</span>
              </div>
            </div>
            <div class="hover_div" @click.stop>
              <div class="div_FSvg" @click="getModuleUpd(item.groupid)">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                  <FSvg title="编辑" color="#fff" hoverColor="#ddd" IconSize="14"></FSvg>
                </el-tooltip>
              </div>
              <div class="div_FSvg" @click="getScreenGroup(item.groupid)">
                <el-tooltip class="item" effect="dark" content="删除" placement="top">
                  <FSvg title="删除" color="#fff" hoverColor="#ddd" IconSize="16"></FSvg>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="addList" @click="getRouterPath('/addStencil')">
            <div class="pseDiv">
              <div>
                <div>
                  <svg viewBox="0 0 1024 1024" version="1.1" style="width: 24px; height: 24px; fill: rgb(221, 221, 221);">
                    <path d="M511.950015 1024c-41.887728 0-75.977741-34.090013-75.977741-75.977741v-359.894562H75.977741c-41.887728 0-75.977741-34.090013-75.977741-75.977741s34.090013-75.977741 75.977741-75.977741h360.094503V75.977741c0-41.887728 34.090013-75.977741 75.977741-75.977741s75.977741 34.090013 75.977741 75.977741v360.094503H947.722347c41.887728 0 75.977741 34.090013 75.977741 75.977741s-34.090013 75.977741-75.977741 75.977741H587.927756V947.722347c0.199941 42.18764-34.090013 76.277653-75.977741 76.277653z" p-id="23429"></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div class="rigStencil">
      <div class="rigTil">
        <div>
          <FSvg title="模块" color="#333" hoverColor="#333"></FSvg>
        </div>
        <span>{{activeStencil.til}}</span>
      </div>
      <div class="rigCount">
        <div class="rigCount_div">
          <div class="dp_forList" v-for="item in activeStencil.child" v-if="activeStencil.child.length">
            <div class="dp_div">
              <img :src="item.thumbNail" ondragstart="return false" @error="imgError">
              <div class="div_count">
                <div class="div_til">
                  <span>{{item.screenPageName}}</span>
                  <div style="margin-right: 0" @click="getstencilDp(item,'upd')">
                    <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                      <FSvg title="编辑" color="#fff" IconSize="15" hoverColor="#eee"></FSvg>
                    </el-tooltip>
                  </div>
                  <div @click="getstencilDp(item,'full')">
                    <el-tooltip class="item" effect="dark" content="全屏" placement="top">
                      <FSvg title="全屏" color="#fff" IconSize="17" hoverColor="#eee"></FSvg>
                    </el-tooltip>
                  </div>
                  <div @click="getstencilDp(item,'del')">
                    <el-tooltip class="item" effect="dark" content="删除" placement="top">
                      <FSvg title="删除" color="#fff" IconSize="17" hoverColor="#eee"></FSvg>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="comNoData" v-if="!activeStencil.child.length">
            <span>暂无大屏</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/4/10 3:00 下午
 */
import {
  GetScreenList,
  RemoveScreen,
  RemoveScreenGroup
} from '@/assets/axios/createScreen/stencilList'

import { pathFullScreen } from '@/assets/js/basis.js'


export default {
  name: 'stencilList',
  components: {},
  props: {},
  data() {
    return {
      //模版列表
      stencilList: [],
      stencil: {
        load: true,
      },
      //选中的模版
      activeStencil: {
        id: '',
        til: '',
        child: [],
      }
    }
  },
  methods: {
    //初始化
    async init() {
      this.delSession('screen_module_xy');
      this.delSession('screen_viewDp_xy');
      this.delSession('screen_type_xy');
      this.getAllList();
    },
    //获取大屏数据
    getAllList() {
      this.stencilList = [];
      this.activeStencil = {
        id: '',
        til: '',
        child: [],
      };
      GetScreenList().then(res => {
        if (res.code === 200) {
          this.stencilList = res.data;
          if (this.stencilList.length) {
            this.getClickModel(0);
          }
        } else {
          this.stencilList = [];
        }
      }).catch(() => {
        this.stencilList = [];
      })
    },
    //模版
    getClickModel(index) {
      if (!this.stencilList.length) {
        this.activeStencil.child = [];
        this.activeStencil.id = '';
        this.activeStencil.til = '';
        return;
      }
      if (this.stencilList[index].groupid === this.activeStencil.id) {
        return;
      }
      this.activeStencil.id = this.stencilList[index].groupid;
      this.activeStencil.til = this.stencilList[index].screenName;
      this.activeStencil.child = this.stencilList[index].child;
    },
    //图片加载失败
    imgError(event) {
      let index = this.randomNum(0, 2).toFixed(0);
      $(event.target).attr('src', require(`./img/dp0${index}.jpg`))
    },
    //大屏操作
    getstencilDp(item, type) {
      if (type === 'del') {
        this.$alert('是否删除当前大屏?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showCancelButton: true,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          customClass: 'alert_allCom',
        }).then(() => {
          this.delScreen(item.id);
        }).catch(() => {

        });
      } else if (type === 'upd') {
        this.setSession({
          //模版
          screen_module_xy: this.activeStencil.id,
          //某一块大屏
          screen_viewDp_xy: item.id,
        });
        this.getRouterPath('/viewScreen');
      } else if (type === 'full') {
        pathFullScreen(item)
      }
    },
    //删除单个大屏
    delScreen(id) {
      RemoveScreen({
        screenID: id
      }).then(res => {
        if (res.code === 200) {
          this.getMsg('删除成功', 'success');
          this.activeStencil.child.map((item, index) => {
            if (item.id === id) {
              this.activeStencil.child.splice(index, 1);
            }
          })
        }
      })
    },
    //模版跳转修改
    getModuleUpd(id) {
      this.setSession({
        //模版
        screen_module_xy: id,
        //某一块大屏
        screen_viewDp_xy: '',
      });
      this.getRouterPath('/viewScreen');
    },
    //删除一组大屏
    getScreenGroup(id) {
      this.$alert('是否删除这一组大屏?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        customClass: 'alert_allCom',
      }).then(() => {
        RemoveScreenGroup({
          groupID: id
        }).then(res => {
          if (res.code === 200) {
            this.getMsg('删除成功', 'success');
            this.stencilList.map((item, index) => {
              if (id === item.groupid) {
                this.stencilList.splice(index, 1)
              }
            });
            this.getClickModel(0);
          }
        })
      }).catch(() => {

      });
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {

  }
}
</script>

<style lang="less">
@borderRadio: 5px;
@borderColor: #ccc;
@shadow: 0 0 10px @h_top_backColor;
@axtive_shadow: 0 0 15px #cb0000;
//大屏一行展示多少条
@dp_size: 4;

.stencilList {
  position: relative;
  background-color: @h_main_backColor !important;
  padding: 0 20px 0 0;

  .leftStencil {
    width: 16%;
    margin-right: 1%;
    height: 100%;
    float: left;
    display: inline-block;
    .noSelect;

    .leftTil {
      display: inline-block;
      width: 100%;
      margin-bottom: 15px;

      > div {
        background-color: @h_path_backColor;
        border-radius: @borderRadio;
        padding: 7px 15px;
        line-height: 30px;
        position: relative;

        .FSpanTil {
          vertical-align: middle;

          svg {
            margin-top: -2px;
          }
        }
      }
    }

    .leftList {
      display: inline-block;
      width: 100%;
      height: calc(100% - 30px - 14px - 15px);
      background-color: #fff;
      border-radius: @borderRadio;
      /*padding: ;*/

      .forList {
        position: relative;
        margin-bottom: 5%;
        width: 94%;
        height: 0;
        padding-bottom: 55%;
        cursor: pointer;
        border-radius: @borderRadio;

        > .stencilDiv {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          border-radius: @borderRadio;

          > img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
          }

          .div_count {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;

            .name {
              position: absolute;
              width: 100%;
              line-height: 35px;
              font-size: 18px;
              color: @green;
              display: inline-block;
              bottom: 0;
              padding: 0 10px;
              text-align: right;
              letter-spacing: 3px;
            }
          }
        }

        .hover_div {
          position: absolute;
          top: 0;
          width: 100%;
          height: 0;
          overflow: hidden;
          background-color: rgba(173, 173, 173, 0.5);
          border-radius: @borderRadio;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          z-index: 2;
          transition: 0.3s height;
          padding: 0 10px;

          .div_FSvg {
            float: right;
            width: 18px;
            height: 18px;
            margin-right: 10px;
            margin-top: 6px;
          }

          .div_FSvg:first-child {
            margin-right: 5px;
          }
        }
      }

      .activeForList {
        box-shadow: @axtive_shadow !important;

        .hover_div {
          height: 30px;
        }
      }

      .forList:hover {
        box-shadow: @shadow;

        .hover_div {
          height: 30px;
        }
      }

      .addList {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 55%;
        overflow: hidden;
        cursor: pointer;
        border-radius: @borderRadio;

        .pseDiv {
          position: absolute;
          top: 0;
          left: 0;
          width: 94%;
          height: 100%;
          padding: 5%;
          border: 1px solid @borderColor;
          background-color: @h_path_backColor;
          border-radius: @borderRadio;

          > div {
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);

            > div {
              text-align: center;

              svg {
                width: 46% !important;
                height: 46% !important;
              }
            }
          }
        }
      }

      .addList:hover {
        box-shadow: @shadow;

        svg {
          fill: @green !important;
          width: 30% !important;
          height: 30% !important;
        }
      }

      .el-scrollbar {
        width: 100%;
        height: 100%;

        .el-scrollbar__wrap {
          overflow-x: hidden;
          padding: 5%;
        }
      }
    }
  }

  .rigStencil {
    background-color: @h_path_backColor;
    border-radius: 10px;
    height: 100%;
    width: calc(100% - 17%);
    float: left;
    display: inline-block;
    padding: 0 20px 20px 20px;
    background: #eaebf7;

    > .rigTil {
      line-height: 30px;
      padding: 10px 15px 0;

      > div {
        display: inline-block;
        float: left;
        vertical-align: middle;
        margin-top: -3px;
      }

      > span {
        display: inline-block;
        margin-left: 10px;
        color: @fontColor;
        float: left;
        font-size: 20px;
        letter-spacing: 3px;
      }
    }

    > .rigCount {
      width: 100%;
      height: calc(100% - 50px);
      padding: 15px;
      overflow-y: auto;
      overflow-x: hidden;
      border-radius: 10px;
      margin-top: 40px;

      .rigCount_div {
        width: calc(100% + 20px);
        height: 100%;

        .dp_forList {
          width: 300px;
          float: left;
          position: relative;
          padding-bottom: calc(300px * 0.55);
          border-radius: @borderRadio;
          margin-right: 15px;
          margin-bottom: 15px;
          background-color: @h_path_backColor;

          .dp_div {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
            border-radius: @borderRadio;
            cursor: pointer;

            > img {
              width: 100%;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 1;
            }

            > .div_count {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 2;

              > .div_til {
                width: 100%;
                border-top-right-radius: @borderRadio;
                border-top-left-radius: @borderRadio;
                background-color: hsl(@green, 70%);
                height: 15%;
                min-height: 30px;
                padding: 0 3%;
                font-size: 14px;
                letter-spacing: 1px;
                position: relative;

                > span {
                  display: inline-block;
                  max-width: 70%;
                  float: left;
                  color: #fff;
                  .com_middle;
                  .text_oneLine;
                }

                > div {
                  width: 18px;
                  height: 18px;
                  float: right;
                  display: inline-block;
                  margin-right: 10px;
                  .com_middle;
                }
              }
            }
          }
        }

        .dp_forList:hover {
          box-shadow: @shadow;
        }
      }
    }
  }
}
.el-scrollbar__wrap {
  margin-bottom: 0px !important;
}
</style>